(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('LenderContactDetailController', LenderContactDetailController);

    LenderContactDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'LenderContact', 'Lender', 'Contact'];

    function LenderContactDetailController($scope, $rootScope, $stateParams, entity, LenderContact, Lender, Contact) {
        var vm = this;

        vm.lenderContact = entity;

        var unsubscribe = $rootScope.$on('valueconnectApp:lenderContactUpdate', function(event, result) {
            vm.lenderContact = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
